import React from 'react';
import { ppData } from '../configs/ppData.config';
import { Ssvg } from '../../../Components/react/Ssvg';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_LAYOUT } from '../constants/searchParamKeys';
const InfoItem = ({ icon, title, text, isLast = false }) => (React.createElement("li", { className: `d:flex jc:center ${!isLast ? 'mr:10' : ''} fx:1` },
    React.createElement("div", { className: "d:flex fd:column fd:row:md-up w:100p w:208:md-up w:100p:lg-up w:208:xl-up" },
        React.createElement(Ssvg, { icon: icon, className: "h:48 h:40:md-up mb:10 mb:0:md-up mr:16:md-up mr:10:lg-up mr:16:xl-up" }),
        React.createElement("div", null,
            React.createElement("p", { className: "m:0 fw:700 fz:12 fz:16:md-up fz:10:lg-up fz:16:xl-up" }, title),
            React.createElement("p", { className: "fz:12 fz:14:md-up fz:10:lg-up fz:14:xl-up" }, text)))));
export const ShippingInfo = () => {
    const [searchParams] = useSearchParams();
    const layout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT);
    if (layout === null)
        return null;
    if (ppData.isPersonalized && layout.includes('poster')) {
        return (React.createElement("div", { className: "mt:24" },
            React.createElement("div", { className: "d:flex ai:center" },
                React.createElement(Ssvg, { icon: "#icon--pm-delivery", className: "h:48 h:40:md-up mr:16 mr:10:lg-up mr:16:xl-up" }),
                React.createElement("p", { className: "m:0 fw:700 fz:12 fz:16:md-up fz:10:lg-up fz:16:xl-up" },
                    "FREE US",
                    React.createElement("br", null),
                    "SHIPPING")),
            React.createElement("p", { className: "mt:8 fz:12 fz:14:md-up fz:10:lg-up fz:14:xl-up" },
                "Enjoy free shipping, no minimum purchase required! Plus, our shipping is superfast! Estimated ",
                window.processingTime.min,
                "-",
                window.processingTime.max,
                " business days to ship, and a total of ",
                window.shippingTime.min,
                "-",
                window.shippingTime.max,
                " business days to arrive. Express option available at checkout.")));
    }
    return (React.createElement("ul", { className: "list:none d:flex jc:between mt:24 lts:001 text:center text:left:md-up" },
        !ppData.isPersonalized &&
            React.createElement(InfoItem, { icon: "#icon--pm-returns", title: "FREE RETURNS", text: "90 days money back guarantee" }),
        !ppData.isTiles && layout.includes('framed')
            ? React.createElement(InfoItem, { icon: "#icon--pm-hang-framed", title: "READY TO HANG", text: "High-quality frame & sawtooth hanger" })
            : ppData.isTiles && (layout === 'foam' || layout === 'framed')
                ? React.createElement(InfoItem, { icon: "#icon--pm-hang-foam", title: "READY TO HANG", text: "Sticker on the back" })
                : React.createElement(InfoItem, { icon: "#icon--pm-hang-canvas", title: "READY TO HANG", text: "100% premium stretched canvas" }),
        React.createElement(InfoItem, { icon: "#icon--pm-delivery", title: "FREE US SHIPPING", text: `${window.shippingTime.min}-${window.shippingTime.max} business days delivery`, isLast: true })));
};
